import { mapState, mapGetters, mapActions } from 'vuex'

export const adminListAgentadminEditComputed = {
  ...mapState('adminListAgentadminEdit', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('adminListAgentadminEdit', [
    'getAgentAdmin',
    'getStatus',
    'getErrors',
  ]),
}

export const adminListAgentadminEditMethods = mapActions(
  'adminListAgentadminEdit',
  ['fetchingAgentAdmin', 'editAgentAdmin', 'resetAgentAdmin']
)
